export const convertArrayToMap = (arr, key) =>
	arr.reduce((acc, v) => {
		if (v[key]) {
			acc[v[key]] = v;
		}
		return acc;
	}, {});
